<template>
  <section class="invoice steps" style="padding-top: 0;padding-bottom: 0;">
    <div class="row">
      <div class="col-md-12">
        <div class="stepwizard">
          <div class="stepwizard-row setup-panel">
            <div class="stepwizard-step">
              <a @click.prevent="goToCart" :to="{name: 'Panier'}" >
                <div :class="{'btn-primary disabled':step==1}" class="btn btn-primary btn-circle ">1</div>
                <p>Votre panier</p>
              </a>
            </div>
            <div class="stepwizard-step">
              <a  :disabled="!getOrder.step1"
                  @click.prevent="goToLivraison" :class="{'disabled':!getOrder.step1}">
                <div :class="{'btn-primary':getOrder.step1, 'btn-default disabled':!getOrder.step1}"
                     class="btn  btn-circle ">2
                </div>
                <p>Livraison</p>
              </a>
            </div>
            <div class="stepwizard-step">
              <a :disabled="!getOrder.step2"
                 @click.prevent="goToChoixPayement" :class="{'disabled':!getOrder.step2}">
                <div
                  :class="{'btn-primary ':getOrder.step2, 'btn-default disabled':!getOrder.step2}"
                  class="btn btn-circle ">3
                </div>
                <p>Moyen de payement</p>
              </a>
            </div>

            <div class="stepwizard-step">
              <a :disabled="!getOrder.step3"
                 @click.prevent="goToConfirm" :class="{'disabled':!getOrder.step3}">
                <div
                  :class="{'btn-primary ':getOrder.step3, 'btn-default disabled':!getOrder.step3}"
                  class="btn btn-circle ">4
                </div>
                <p>Confirmation</p>
              </a>
            </div>
            <div class="stepwizard-step" v-show="getModePayement!=null && getModePayement=='payementElectronique'">
              <a :disabled="!getOrder.step4" @click.prevent="goToConfirm" :class="{'disabled':!getOrder.step4}">
                <div
                  :class="{'btn-primary ':getOrder.step4, 'btn-default disabled':!getOrder.step4}"
                  class="btn btn-circle ">5
                </div>
                <p>Payement</p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script type="text/babel">
  import Auth from '@/auth'
  import {mapGetters, mapActions} from 'vuex'

  export default {
    props: {
      step: {
        required: true,
        default: 1
      }
    },
    data() {
      return {}
    },
    methods: {
      ...mapActions({
        setStepOrder:'setStepOrder'
      }),
      goToCart:function() {
        this.setStepOrder({step:'step1',value:false})
        this.setStepOrder({step:'step2',value:false})
        this.setStepOrder({step:'step3',value:false})
        this.setStepOrder({step:'step4',value:false})
        this.$router.push({name: 'Panier'});
      },
      goToLivraison:function() {
        if (!this.getOrder.step1)
          return
        this.setStepOrder({step:'step2',value:false})
        this.setStepOrder({step:'step3',value:false})
        this.setStepOrder({step:'step4',value:false})
        this.$router.push({name: 'Livraison'});
      },
      goToChoixPayement:function() {
        if (!this.getOrder.step2)
          return
        this.setStepOrder({step:'step3',value:false})
        this.setStepOrder({step:'step4',value:false})
        this.$router.push({name: 'ChoixPayement'});
      },
      goToConfirm:function() {
        if (!this.getOrder.step3)
          return
        this.setStepOrder({step:'step4',value:false})
        this.$router.push({name: 'Confirm'});
      },
    },
    components: {},
    computed: {
      ...mapGetters({
        getOrder:'getOrder',
        getModePayement: 'getModePayement',

      })
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/stepsOrder.vue